import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";

const useMaintenanceDataTable = (formik, setDeleteMaintenanceID, setShowDeleteMaintenanceModal) => {
    const addItemOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`maintenance[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const {
        vendorNameDropdown, 
        setVendorNameDropdown, 
        employeeNameDropdown,
        setEmployeeNameDropdown,
        vendorNameList,
        employeeNameList,
    } = useItemDropdown();

    const modalMaintenanceTableColumns = [
        {
            field: "vendor",
            header: "Vendor",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="vendor"
                        name="vendor"
                        autoFilteredValue={vendorNameDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setVendorNameDropdown, vendorNameList)}
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "vendor")}
                        value={formik.values.maintenance[event.rowIndex]?.vendor}
                        type="select"
                        label="Select Vendor"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        errors={formik.errors.maintenance?.[event.rowIndex]?.vendor?.id}
                    />
                </div>
            ),
        },
        {
            field: "immediate_user",
            header: "Immediate User",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="immediate_user"
                        name="immediate_user"
                        autoFilteredValue={employeeNameDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setEmployeeNameDropdown, employeeNameList)}
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "immediate_user")}
                        value={formik.values.maintenance[event.rowIndex]?.immediate_user}
                        type="select"
                        label="Select User"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        errors={formik.errors.maintenance?.[event.rowIndex]?.immediate_user}
                    />
                </div>
            ),
        },
        {
            field: "send_date",
            header: "Send Date",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField 
                        id="send_date"
                        name="send_date"
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "send_date")}
                        value={formik.values.maintenance[event.rowIndex]?.send_date}
                        type="date"
                        width="full"
                        autoCompleteFieldName="send_date"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.maintenance?.[event.rowIndex]?.send_date}
                    />
                </div>
            ),
        },
        {
            field: "receive_date",
            header: "Receive Date",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField 
                        id="receive_date"
                        name="receive_date"
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "receive_date")}
                        value={formik.values.maintenance[event.rowIndex]?.receive_date}
                        type="date"
                        width="full"
                        autoCompleteFieldName="receive_date"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.maintenance?.[event.rowIndex]?.receive_date}
                    />
                </div>
            ),
        },
        {
            field: "issue",
            header: "Issue",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField 
                        id="issue"
                        name="issue"
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "issue")}
                        value={formik.values.maintenance[event.rowIndex]?.issue}
                        type="text"
                        width="full"
                        autoCompleteFieldName="issue"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.maintenance?.[event.rowIndex]?.issue}
                    />
                </div>
            ),
        },
    ]

    const deleteMaintenanceItems = (rowData) => {
        const {id, asset} = rowData;
        setDeleteMaintenanceID({id, asset})
        setShowDeleteMaintenanceModal(true)
    }

    const modalMaintenanceTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.maintenance.concat({
                fieldId: rowIndex + 1,
                vendor: "",
                immediate_user: "",
                send_date: "",
                receive_date: "",
                issue: "",
            });
            formik.setFieldValue("maintenance", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteMaintenanceItems(rowData)
            }
            const removeData = [...formik.values.maintenance];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("maintenance", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.maintenance.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.maintenance.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalMaintenanceTableColumns,
        modalMaintenanceTableActionButton,
    }
}

export default useMaintenanceDataTable